<template>
  <div class="icon-member">
    <img
      src="../assets/images/vip.svg"
      alt=""
    >
  </div>
</template>

<script>
import { Radio } from "vant";

export default {
  components: {
    [Radio.name]: Radio
  },
  name: "sby-member-icon",
  props: {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
@import "../assets/less/var.less";

.icon-member {
  line-height: 13px;
  display: inline-flex;
  img {
    height: 14px;
    border-radius: 5px 0 0 5px;
  }
  span {
    margin-left: -1px;
    font-size: 8px;
    height: 12px;
    background-color: #04789c;
    color: #fff;
    display: inline-block;
    padding: 2px 3px;
    border-radius: 0 5px 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sby-member-icon.vue